/* eslint-disable no-unused-vars */
import { useEffect, useLayoutEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  managerQuickActions,
  transactionTypesMap,
  userTypeMap,
} from "../../utils/helpers/mappers";

const DashboardMenu = ({
  domainBrand,
  transTypes,
  profile,
  showMoreState,
  canShowMore,
}) => {
  const history = useHistory();

  const [width, setWidth] = useState(0);
  const [cards, updateCards] = useState(0);
  const [cardsRow, updateCardsRow] = useState(2);
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );
  const userType =
    profile.userData["customerType"] === null
      ? profile.userData["userType"]
      : profile.userData["customerType"];
  const visibleCardsCount = transTypes.filter((forEach) =>
    transactionTypesMap[forEach].visibleTo.includes(userType)
  ).length;

  const routeToPage = (event, type) =>
    history.push(`${type.to}`, {
      text: type.text,
      title: type?.title,
      data: type,
    });

  useLayoutEffect(() => {
    const updateSize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    if (width < 640) updateCardsRow(4);
    else if (width <= 1024) updateCardsRow(4);
    else if (width <= 1280) updateCardsRow(4);
    else updateCardsRow(6);
  }, [width]);

  useEffect(() => {
    if (visibleCardsCount > cardsRow) canShowMore(true);
    else canShowMore(false);
  }, [visibleCardsCount, cardsRow]);

  useEffect(() => {
    if (showMoreState) updateCards(visibleCardsCount + 1);
    else updateCards(cardsRow + 1);
  }, [showMoreState, cardsRow]);

  const userModules = profile?.userData?.modules;
  const getUserType = profile?.userData?.userType;
  const userMap = userTypeMap[getUserType];
  const objectMap =
    userModules !== undefined &&
    userModules?.map((type) => {
      let temp = [];
      let i = [];

      if (userMap !== undefined && userMap[type] !== undefined) {
        i = userMap[type];
      }
      temp = i !== undefined ? [...i] : [];
      return temp;
    });

  const mergeTo = (objectMap) => {
    let temp2 = [];
    if (objectMap?.length > 1) {
      for (let i = 0; i < objectMap?.length; i++) {
        let tempVariable = objectMap[i];
        for (let j = i + 1; j < objectMap?.length; j++) {
          if (
            tempVariable?.length > 0 &&
            objectMap[j]?.length > 0 &&
            objectMap[0]?.length > 0
          ) {
            const a = [...objectMap[i], ...objectMap[j], ...objectMap[0]];
            temp2 = [...new Set(a)];
          } else {
            const a = [...objectMap[i], ...objectMap[j], ...objectMap[0]];
            temp2 = [...new Set(a)];
          }
        }
      }
      const unique = [...new Map(temp2?.map((m) => [m.to, m])).values()];
      return unique;
    } else {
      const newObjMap = objectMap !== undefined ? objectMap[0] : [];
      return newObjMap;
    }
  };

  const newMerger = (objectMap) => {
    let newTemp = [];
    if (getUserType === "MANAGER" && objectMap?.length > 1) {
      for (let i = 0; i < objectMap?.length; i++) {
        if (objectMap[i]?.length > 0) {
          const a = [...objectMap[i], ...objectMap[0]];
          newTemp = [...new Set(a)];
        }
      }
      const unique = [...new Map(newTemp?.map((m) => [m.text, m])).values()];
      return unique;
    } else {
      return objectMap[0];
    }
  };

  const useUserTypeToRenderData = () => {
    if (getUserType === "MANAGER") {
      return newMerger(objectMap);
    } else {
      const newObjectMapper = mergeTo(objectMap);
      return newObjectMapper;
    }
  };

  return (
    <>
      <div
        className={`row w-100 ${
          useUserTypeToRenderData()?.length > 5
            ? "card-dashboard-center"
            : "card-dashboard-center"
        }`}
      >
        {useUserTypeToRenderData()?.map((type, idx) => {
          return (
            <div
              className={`col-xl-2 col-lg-3 col-md-4 col-sm-4 col-xs-6`}
              key={idx + idx}
            >
              <div
                onClick={(event) => routeToPage(event, type)}
                className={`card mx-2 pointer shadow }`}
              >
                <div className="card-body text-center">
                  {/*<i className={`${type.icon} text-primary fa-2x`}/>*/}
                  <img src={type.iconSvg} alt="arrowRight" />
                  <h6 className="mt-2 fs-12 mb-2">
                    {dictionary && dictionary[type.lingualText] !== undefined
                      ? dictionary[type.lingualText]
                      : type.text}
                  </h6>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DashboardMenu;

// To be fixed
// fund treasury acc
// view treasury acc
// withdraw from treasury acc
